export { SetupWidget } from './SetupWidget';
export type { SetupWidgetProps } from './SetupWidget';
export type {
  SetupWidgetState,
  SetupWidgetData,
  SetupWidgetStep,
  SetupWidgetStepStatus,
  SetupWidgetConfig,
} from '@wix/bex-core';
